import React, { FC, useMemo } from 'react';
import { useTranslate } from '@/translations';
import { Storage } from '@/types';
import { CustomColumns, CustomTable } from '@/ui/components';
import { useStorage } from '@/api/Storage';

export const StorageDataGrid: FC = () => {
  const { data, isFetching: isLoading } = useStorage();
  const storageData = data?.entities;

  const dataSource = useMemo(() => {
    if (storageData) {
      return [
        ...new Map(storageData?.map((item) => [item.count, item])).values(),
      ];
    }
    return [];
  }, [storageData]);

  const { t } = useTranslate();

  const columns: CustomColumns<Storage> = useMemo(
    () => [
      {
        dataIndex: 'locationCode',
        title: t('client'),
        sortable: true,
        filter: true,
        ellipsis: true,
      },
      {
        dataIndex: 'site',
        title: t('site'),
        sortable: true,
        filter: true,
        ellipsis: true,
      },
      {
        dataIndex: 'locationDesc',
        title: t('locationDescription'),
        sortable: true,
        ellipsis: true,
      },
      {
        dataIndex: 'count',
        title: t('count'),
        sortable: true,
        ellipsis: true,
        render: (text) => Number(text).toLocaleString(),
      },
      {
        dataIndex: 'capacity',
        title: t('capacity'),
        sortable: true,
        ellipsis: true,
        render: (text) => Number(text).toLocaleString(),
      },
      {
        dataIndex: 'utilisation',
        title: t('utilisation'),
        sortable: true,
        ellipsis: true,
        render: (text) => `${(text * 100).toFixed(2)}%`,
      },
    ],
    [t],
  );

  return (
    <CustomTable
      dataSource={dataSource}
      columns={columns}
      rowKey="locationId"
      loading={isLoading}
    />
  );
};
